<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Usuarios</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>

            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="usuarionombre"
                          label="Nombre Completo"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="usuario"
                          label="Nombre del Usuario"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="usuariomail"
                          label="Correo Electronico"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          type="password"
                          v-model="usuariopassword"
                          label="password"
                          outlined
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="rolid"
                          :items="rolselect"
                          label="Rol"
                          outlined
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-select
                          v-model="empresaid"
                          :items="empresaselect"
                          label="Nombre de la Empresa"
                          outlined
                        ></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <v-row
                          class="red--text"
                          v-for="v in validamensaje"
                          :key="v"
                          v-text="v"
                        ></v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="guardar"
                    >Guardar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="adModal" max-width="290">
              <v-card>
                <v-card-title class="headline" v-if="adAccion == 1"
                  >¿Activar Usuario?</v-card-title
                >
                <v-card-title class="headline" v-if="adAccion == 2"
                  >¿Desactivar Usuario?</v-card-title
                >
                <v-card-text>
                  Estás a punto de
                  <span v-if="adAccion == 1">Activar</span>
                  <span v-if="adAccion == 2">Desactivar</span>
                  el Usuario {{ adNombre }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" @click="activarDesactivarCerrar"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 1"
                    color="orange darken-4"
                    @click="activar"
                    >Activar</v-btn
                  >
                  <v-btn
                    v-if="adAccion == 2"
                    color="orange darken-4"
                    @click="desactivar"
                    >Desactivar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editItem(item)" v-on="on"
                >edit</v-icon
              >
            </template>
            <span>Editar Usuario</span>
          </v-tooltip>

          <template v-if="item.usuarioestatus == 1">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="ActivarDesactivarMostrar(2, item)"
                  v-on="on"
                  >block</v-icon
                >
              </template>
              <span>Desactivar </span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  dense
                  class="mr-2"
                  @click="ActivarDesactivarMostrar(1, item)"
                  v-on="on"
                  >check</v-icon
                >
              </template>
              <span>Activar </span>
            </v-tooltip>
          </template>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.usuarioestatus="{ item }">
          <v-chip
            :color="getColor(item.usuarioestatus)"
            dark
            v-if="item.usuarioestatus == 1"
            >ACTIVO</v-chip
          >
          <v-chip
            :color="getColor(item.usuarioestatus)"
            dark
            v-if="item.usuarioestatus == 2"
            >SUSPENDIDO</v-chip
          >
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      // Variable de Imagen
      file: [],
      // Variable categoria
      usuarios: [],
      dialog: false,
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Nombre", value: "usuarionombre" },
        { text: "Cuenta", value: "usuario" },
        { text: "Email", value: "usuariomail", sortable: false },
        { text: "Estado", value: "usuarioestatus", sortable: false },
      ],
      search: "",
      editedIndex: -1,
      //
      usuarionombre: "",
      usuariomail: "",
      usuario: "",
      usuariopassword: "",
      usuarioid: "",

      valida: 0,
      validamensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      //
      dismissSecs: 5,
      dismissCountDown: 0,
      usuariocuenta: "",
      status: 0,
      rolid:"",
      rolselect: [],
      //
      empresaid: "",
      empresaselect: [],

      data: [],

      rolselect:[
      { text: "ADMINISTRADOR", value: 1 },
      { text: "SUPERVISOR", value: 2 },
      { text: "CONSULTAS", value: 3 },
      { text: "CONTROL TOTAL", value: 4 },
      { text: "DESPACHADOR", value: 5 }
    ],
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Usuario" : "Actualizando Usuario";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.selectempresa();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103"; // Verde
      if (socioestatus == 2) return "#DA0707"; // Rojo
    },
    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/usuarios/listar", configuracion)
        .then(function (response) {
          me.usuarios = response.data.usuarios;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectempresa() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/empresas/listar", configuracion)
        .then(function(response) {
          listaArray = response.data.empresa;
          listaArray.map(function(x) {
            me.empresaselect.push({
              text: x.empresanombre,
              value: x.empresaid,
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Actualiza la categotia
    editItem(item) {
      this.editedIndex = 1;
      this.dialog = true;
      this.usuarionombre = item.usuarionombre;
      this.usuariomail = item.usuariomail;
      this.usuario = item.usuario;
      //this.usuariopassword = item.usuariopassword;
      this.usuarioid = item.usuarioid;
      this.rolid=item.rolid;
      this.empresaid=item.sucursalid;
    },

    close() {
      this.reportes = false;
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.editedIndex = -1;
      this.usuarionombre = "";
      this.usuariomail = "";
      this.usuario = "";
      this.usuariopassword = "";
      this.rolid="";
    },

    guardar() {
      if (this.validar()) {
        return;
      }
      var qs = require("qs");
      var data = qs.stringify({
        json:
          '{"usuarionombre":"' +
          this.usuarionombre +
          '","usuariomail":"' +
          this.usuariomail +
          '","usuario":"' +
          this.usuario +
          '","usuariopassword":"' +
          this.usuariopassword +
          '","rolid":"' +
          this.rolid +
          '","usuarioid":"' +
          this.$store.state.usuario.usuarioid +
          '","sucursalid":"' +
          this.empresaid +
          '"}',
      });

      if (this.editedIndex > -1) {
        //Editar
        
        let me = this;
        let header = { Authorization: this.$store.state.token };
        let configuracion = { headers: header };
        axios
          .post("api/usuarios/update",  {
            usuarioid:me.usuarioid,
            usuarionombre:me.usuarionombre,
            usuariomail:me.usuariomail,
            usuario:me.usuario,
            usuariopassword:me.usuariopassword,
            rolid:me.rolid,
            sucursalid:me.empresaid

          }, configuracion)
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Usuario Actualizado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      } else {
        //Guardar
        let me = this;
        let header = { Authorization: this.$store.state.token };
        let configuracion = { headers: header };
        axios
          .post("api/usuarios/crear", {
            usuarioid:me.usuarioid,
            usuarionombre:me.usuarionombre,
            usuariomail:me.usuariomail,
            usuario:me.usuario,
            usuariopassword:me.usuariopassword,
            rolid:me.rolid,
            usuarioid:me.$store.state.usuario.usuarioid,
            sucursalid:me.empresaid

          }, configuracion)
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$swal("Usuario Guardado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.usuarionombre) {
        this.validamensaje.push("Ingrese Nombre Completo");
      }
      if (!this.usuariomail) {
        this.validamensaje.push("Ingrese un Email.");
      }
      if (!this.usuario) {
        this.validamensaje.push("Usuario Cuenta Vacio.");
      }
      if (!this.usuariopassword) {
        this.validamensaje.push("Ingrese un Password.");
      }
      if (!this.rolid) {
        this.validamensaje.push("Ingrese un Rol.");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }

      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.usuarioid = item.usuarioid;
      this.adNombre = item.nombre;
      this.adId = item.idusuario;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"usuarioestatus":"1"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/usuarios/activar/" + this.usuarioid, data, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    desactivar() {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"usuarioestatus":"2"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/usuarios/activar/" + this.usuarioid, data, configuracion)
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
  },
};
</script>